"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SuccessIcon = _interopRequireDefault(require("../SuccessIcon"));
var OrderCancellationRequestSent = function OrderCancellationRequestSent(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$success = props.success,
    success = _props$success === void 0 ? true : _props$success,
    _props$header = props.header,
    header = _props$header === void 0 ? '' : _props$header,
    _props$description = props.description,
    description = _props$description === void 0 ? '' : _props$description,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile;
  return /*#__PURE__*/_react["default"].createElement(StyledOrderCancellationPopup, {
    className: className,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(_SuccessIcon["default"], {
    success: success
  }), header ? /*#__PURE__*/_react["default"].createElement(StyledHeader, null, header) : null, description ? /*#__PURE__*/_react["default"].createElement(StyledDescription, null, description) : null);
};
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "OrderCancellationRequestSent__StyledHeader",
  componentId: "sc-xh58rf-0"
})(["margin-top:16px;font-weight:500;font-size:22px;line-height:26px;color:#17181a;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "OrderCancellationRequestSent__StyledDescription",
  componentId: "sc-xh58rf-1"
})(["margin-top:8px;font-size:14px;color:#4d4d4d;text-align:center;"]);
var StyledOrderCancellationPopup = _styledComponents["default"].div.withConfig({
  displayName: "OrderCancellationRequestSent__StyledOrderCancellationPopup",
  componentId: "sc-xh58rf-2"
})(["width:", "px;background:#f3f2e8;padding:32px 16px;display:flex;flex-direction:column;align-items:center;border-radius:4px;"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 320 : 800;
});
var _default = exports["default"] = OrderCancellationRequestSent;